// ##############################
// // // Lightbox component styles
// #############################

const selectStyle = {
    label: {
        transform: 'translate(0, 10px) scale(1)'
    },
    select: {
        marginTop: '0px !important',
        paddingTop: '4px !important',
    }
};

export default selectStyle;



// WEBPACK FOOTER //
// ./src/common/CustomSelect/styles.jsx